import React, { useCallback, useState, useMemo, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import { withTrackProps } from '@dpdgroupuk/react-event-tracker';

import RightDrawerModal from '../../RightDrawerModal';
import Button from '../../Button';
import palette from '../../../components/styles/palette';
import SliderCard from '../../SliderCard';
import NestedSelect from '../../NestedSelect';
import { joinArrayToString } from '../../../utils/string';
import {
  SELECT_MULTIPLE,
  CONFIRM,
  SELECT_ALL_STOPS,
  FROM,
  TO,
  LUNCH_BREAK,
} from '../../../constants/strings';
import { isBreakStop } from '../../../models/stop';
import { SELECT_MULTIPLE_MODAL } from '../../../constants/analytics';

const useStyles = makeStyles((theme) => ({
  content: {
    maxWidth: theme.typography.pxToRem(780),
  },
  divider: {
    height: theme.typography.pxToRem(30),
  },
}));

// TODO move it out or pass as props to component
const formatRouteStopLabel = (routeStop) => {
  if (isBreakStop(routeStop)) {
    return joinArrayToString(
      [routeStop?.displayNumber, LUNCH_BREAK.toUpperCase()],
      ' - '
    );
  }

  const address = joinArrayToString([
    routeStop?.stopAddress?.contactName,
    routeStop?.stopAddress?.address1,
  ]);

  return joinArrayToString(
    [routeStop?.displayNumber, routeStop?.stopAddress?.postcode, address],
    ' - '
  );
};

const SelectMultipleRouteStops = ({
  open,
  onConfirm,
  onClose,
  routeStops = [],
}) => {
  const classes = useStyles();
  const [fromIndex, setFromIndex] = useState(null);
  const [toIndex, setToIndex] = useState(null);

  const routeStopOptions = useMemo(
    () =>
      routeStops.map((routeStop, index) => ({
        value: index,
        label: formatRouteStopLabel(routeStop),
      })),
    [routeStops]
  );

  const isSaveDisabled = useMemo(
    () => fromIndex == null || toIndex == null,
    [fromIndex, toIndex]
  );

  const handleSaveClick = useCallback(() => {
    onConfirm({
      from: fromIndex,
      to: toIndex,
    });
  }, [fromIndex, onConfirm, toIndex]);

  useEffect(() => {
    if (!open && (fromIndex != null || toIndex != null)) {
      setFromIndex(null);
      setToIndex(null);
    }
  }, [open, fromIndex, toIndex]);

  return (
    <RightDrawerModal
      open={open}
      onClose={onClose}
      title={SELECT_MULTIPLE.toUpperCase()}
      loadId={SELECT_MULTIPLE_MODAL.LOAD}
      actions={
        <Button
          data-testid="save"
          variant="contained"
          disabled={isSaveDisabled}
          opacityDisabled={0.38}
          bgColor={palette.modalButtons.blue}
          border={palette.btn.blueBorder}
          onClick={handleSaveClick}
        >
          {CONFIRM}
        </Button>
      }
    >
      <SliderCard title={SELECT_ALL_STOPS}>
        <Box className={classes.content}>
          <NestedSelect
            value={fromIndex}
            onChange={setFromIndex}
            options={routeStopOptions}
            label={FROM}
          />

          <Box className={classes.divider} />

          <NestedSelect
            value={toIndex}
            onChange={setToIndex}
            options={routeStopOptions}
            label={TO}
          />
        </Box>
      </SliderCard>
    </RightDrawerModal>
  );
};

export default withTrackProps({
  onConfirm: SELECT_MULTIPLE_MODAL.SELECT_CONFIRM,
  onClose: SELECT_MULTIPLE_MODAL.SELECT_CLOSE,
})(SelectMultipleRouteStops);
